<template>
  <div class='datasource_wrap' :key="activeNavId">
        <!-- 简介 -->
        <div class="top_img">
            <div class="top_title">科研合作数据</div>
            <div class="top_content">数据领域包含多个方面-金融财经、行业产业以及创新事件数据，整合了教育、学术研究过程中可能用到的大部分基础数据。</div>
        </div>
        <!-- 导航 -->
        <!-- <div class="nav_wrap flex-center">
            <div @click="activeNavId = 0" class="flex-column-content mouse-hover" :class="{'active_nav':activeNavId == 0}">
                <div><i class="iconfont icon-quanmian" >&nbsp;通用数据</i></div>
                <div>(数据种类全面且随时开放下载)</div>
            </div>
            <div @click="activeNavId = 1" class="flex-column-content mouse-hover" :class="{'active_nav':activeNavId == 1}">
                <div><i class="iconfont icon-keyanqianxian">&nbsp;科研合作数据</i></div>
                <div>(与各项高校及研究机构合作研发)</div>
            </div>
        </div> -->
        <!-- 分类列表 -->
        <div class="mid_wrap flex-start">
            <div class="mid_item flex-center mouse-hover"  v-for="item in  (activeNavId == 0 ? resourceList : researchList)" :key="item.id" :class="item.isOpen ? 'mid_wrap_hover' : 'mid_wrap_hover_not'" @click="intoItem(item.id)">
                <i :class="item.icon" class="list_icon" ></i>
                <div class="item_list">
                    <div class="list_title">{{item.title}}</div>
                    <div class="list_content flex-start"><div class="mian_list">{{item.main}}</div><div v-for="(n,i) in item.list" :key="i" class="lists">{{n}}</div></div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
        resourceList:[
            {   id:30,
                icon:`iconfont icon-gupiao3`,
                title:'股票数据',
                // list:['中国股票','美国股票','中国香港股票','...']
                main:'包含中国市场及美国市场的股票数据',
                isOpen:true
            },
            {   id:31,
                icon:`iconfont icon-gupiao2 `,
                title:'期货数据',
                // list:['商品期货','金融期货','外盘','...']
                // main:'包含期货基础数据、行情数据、南华指数、CFMMC指数等'
                main:'包含商品期货数据、金融期货数据与南华指数',
                isOpen:true
            },
            {
                id:34,
                icon:`iconfont icon-shujutongji`,
                title:'宏观数据',
                isOpen:true,
                // list:['中国宏观','美国宏观','欧元区宏观','...']
                main:'包含中国、美国、欧元区、德国以及重要机构宏观数据'
            },
            {
                id:32,
                icon:`iconfont icon-shuju `,
                title:'期权数据',
                // list:['商品期货','金融期货','外盘','...']
                main:'包含商品期权及金融期权的主要数据',
                isOpen:true
            },
            {
                id:33,
                icon:`iconfont icon-DVLINK_waihuiziben`,
                title:'外汇数据',
                isOpen:true,
                main:'包含主要国家外汇数据'
            },
            {
                id:35,
                icon:`iconfont icon-zu2327`,
                title:'能源数据',
                isOpen:true,
                // list:['碳排放权-北京','...','碳排放权-广州','...']
                main:'包含各大城市碳排放数据'
            },
            {
                id:36,
                icon:`iconfont icon-qitalei `,
                title:'另类数据',
                isOpen:true,
                main:'包含不同领域、不同产业、不同行业的数据'
            },
            {
                id:37,
                icon:`iconfont icon-dengdaitianchong `,
                isOpen:false,
                main:'更多领域数据即将开放...'
            },
        ],
        researchList: [
            {
                id: 1,
                icon: `iconfont icon-V`,
                title: '科创板IPO问询数据',
                isOpen: true,
                main: '包含科创板的所有上市公司的IPO问询数据'
            }, {
                id: 2,
                icon: `iconfont icon-qiye`,
                title: '创业板IPO问询数据',
                isOpen: true,
                main: '包含创业板的所有上市公司的IPO问询数据'
            }
        ],
        activeNavId:this.$route.query.id
    }
},
created(){

},
methods:{
    intoItem(index){
        this.$store.commit('setPageId',{pageId:index})
        switch(index){
            // 股票数据
            case 30:
                this.$router.push('/dataSourceStockData')
            break;
            // 期货数据
            case 31:
                this.$router.push('/dataSourceFuturesData')
            break;
            // 期权数据
            case 32:
                this.$router.push('/optionData')
            break;
            // 外汇数据
            case 33:
                this.$router.push('/foreignData')
            break;
            // 能源数据
            case 35:
                this.$router.push('/energyData')
            break;
            break;
            // 另类数据
            case 36:
                this.$router.push('/otherData')
            break;
            // 科创板IPO问询数据
            case 1:
                this.$router.push("/researchData?name=科创板IPO问询数据")
            break;
            // 创业板IPO问询数据
            case 2:
                this.$router.push('/researchData?name=创业板IPO问询数据');
                break;
            //宏观数据
            case 34:
                this.$router.push('/macroData');
                break;
        }
    }
}
}
</script>

<style lang='scss' scoped>

.datasource_wrap{
    width: 100%;
    padding-bottom: 200px;
    .top_img{
        width: 100%;
        height: 580px;
        background: url(../../assets/img/top_img2.png) 0 0/100% 100% no-repeat;
        color: #fff;
        .top_title{
            width: 200px;
            font-size: 45px;
            font-weight: bold;
            margin: 0px 0 40px 65%;
            position: relative;
            top: 250px;
        }
        .top_content{
            width: 620px;
            font-size: 22px;
            margin-left: 65%;
            margin-top: 280px;
        }
    }
    .nav_wrap{
            width: 100%;

        background: #53438F;
            >div{
                width: 50%;
                height: 140px;
                box-sizing: border-box;
                text-align: center;
                color: white;
                line-height: 1.7;
                i{
                    font-size: 21px;
                }
            }
            .active_nav{
                background: url(../../assets/img/btn_right.png) 0 0/100% 100% no-repeat;
            }
    }
    .mid_wrap{
        width: 100%;
        padding: 100px 10%;
        flex-wrap: wrap;
        position: relative;
        box-sizing: border-box;
        .mid_item{
            padding: 30px;
            box-shadow: 0px 0px 4px #C9C9C9;
            width: calc((100% - 150px) / 3) ;
            height: 180px;
            box-sizing: border-box;
            overflow: hidden;
            margin: 20px 25px ;
            .list_icon{
                font-size: 60px;
                margin: 0px 25px 0px 0px;
            }
            .list_title{
                font-size: 22px;
                font-weight: bold;
                margin-bottom: 20px;
            }
            .list_content{
                line-height: 1.6;
            }
        }
    }
    .buttom_wrap{
            width: 100%;
            padding-bottom: 200px;
            // background: crimson;
            .but_img{
                width: 1599px;
                height: 391px;
                background: url(../../assets/img/button_img2.png) 0 0/100% 100% no-repeat;
                margin-left: calc(50% - 800px);
                .but_conten{
                    width: 40%;
                    margin-left: 45%;
                    font-size: 24px;
                    line-height: 50px;
                }
            }
    }

}
.mid_wrap_hover {
    i{
        color: #59ADF8;
        font-size: 25px;
    }
    &:hover{
        color: #fff ;
        background: #7052CD;
        box-shadow: 0px 0px 12px #580093 !important;
        border-radius: 4px;
        i{
            color: #fff
        }
    }
}
.mid_wrap_hover_not{
    color: #999;
    &:hover{
        background:#C9C9C9;
        color: #fff;
    }
}
</style>
